import { GiphyFetch } from '@giphy/js-fetch-api'
import { Gif } from '@giphy/react-components'
import React from 'react'

const giphyFetch = new GiphyFetch(process.env.REACT_APP_GIPHY_API_KEY) // FIXME: change api key

const Giphy = ({ gifId }) => {
    const [gif, setGif] = React.useState(null)

    const fetchGif = async gifId => {
        try {
            const { data } = await giphyFetch.gif(gifId)
            setGif(data)
        } catch (error) {
            console.log('error in fetching gif data :- ', error)
        }
    }

    React.useEffect(() => {
        fetchGif(gifId)
    }, [gifId])

    return gif && <Gif gif={gif} width="100%" borderRadius="100%" />
}

export { Giphy }
